import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { JsonApiWrap } from "../../shared/models/JsonApiWrap";
import { BaseRestService } from "../../shared/services/BaseRestService";
import { HeadersService } from "../../shared/utilities/HeadersService";
import { CheckData } from "../models/check/CheckData";
import { CheckAcknowledgeRequest } from "../models/check/CheckAcknowledgeRequest";
import { CheckInputRequest, StandingAuthInputRequest } from "../models/check/CheckInputRequest";
import { CheckVerifyRequest } from "../models/check/CheckVerifyRequest";
import { FeatureFlagService } from '../../shared/services/feature-flag-service';
import { IntegrationService } from "../../shared/services/integration.service";
import { SharedActions } from "../../shared/actions";

@Injectable({
    providedIn: 'root'
})
export class CheckService {

    acknowledgementConsentEnabled: boolean;

    constructor(private http: HttpClient,
        private headersService: HeadersService,
        private baseService: BaseRestService,
        private store: Store,
        private featureFlagService: FeatureFlagService,
        private integrationService: IntegrationService) { }

    mmExperienceApiPath: string = 'api/ria.MoneyMovementExperience';

    callUseSloaProfile(requestData: StandingAuthInputRequest): Observable<CheckData> {
        let serviceUrl = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + '/v1/CheckUseSloaProfile';
        let requestBody: JsonApiWrap<StandingAuthInputRequest> = {
            data: {
                attributes: requestData,
                type: 'check-input-request',
                id: ''
            }
        }
        let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');

        return this.baseService.post<StandingAuthInputRequest, CheckData>(serviceUrl, headers, requestBody, true);
    }

    callOneTimeCheckInput(requestData: CheckInputRequest): Observable<CheckData> {
        let serviceUrl = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + '/v1/CheckOneTimeInput';
        let requestBody: JsonApiWrap<CheckInputRequest> = {
            data: {
                type: 'check-input-request',
                id: '',
                attributes: requestData
            }
        }
        let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');

        return this.baseService.post<CheckInputRequest, CheckData>(serviceUrl, headers, requestBody, true);
    };

    callRecurringCheckInput(requestData: CheckInputRequest): Observable<CheckData> {
        let serviceUrl = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + '/v1/CheckRecurringInput';
        let requestBody: JsonApiWrap<CheckInputRequest> = {
            data: {
                type: 'check-input-request',
                id: '',
                attributes: requestData
            }
        }
        let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');

        return this.baseService.post<CheckInputRequest, CheckData>(serviceUrl, headers, requestBody, true);
    };

    callOneTimeCheckVerify(requestData: CheckVerifyRequest): Observable<CheckData> {
        let serviceUrl = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + '/v1/CheckOneTimeVerify';
        let requestBody: JsonApiWrap<CheckVerifyRequest> = {
            data: {
                type: 'check-verify-request',
                id: '',
                attributes: requestData
            }
        }
        let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');

        return this.baseService.post<CheckVerifyRequest, CheckData>(serviceUrl, headers, requestBody, true);
    };

    callRecurringCheckVerify(requestData: CheckVerifyRequest): Observable<CheckData> {
        let serviceUrl = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + '/v1/CheckRecurringVerify';
        let requestBody: JsonApiWrap<CheckVerifyRequest> = {
            data: {
                type: 'check-verify-request',
                id: '',
                attributes: requestData
            }
        }
        let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');

        return this.baseService.post<CheckVerifyRequest, CheckData>(serviceUrl, headers, requestBody, true);
    };

    callOneTimeCheckAcknowledge(requestData: CheckAcknowledgeRequest): Observable<CheckData> {
        let serviceUrl = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + '/v1/CheckOneTimeAcknowledge';
        let requestBody: JsonApiWrap<CheckAcknowledgeRequest> = {
            data: {
                type: 'check-acknowledge-request',
                id: '',
                attributes: requestData
            }
        }
        let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');
            headers["Acknowledgement-Consent"] = "true";

        return this.baseService.post<CheckAcknowledgeRequest, CheckData>(serviceUrl, headers, requestBody, true);
    };

    callRecurringCheckAcknowledge(requestData: CheckAcknowledgeRequest): Observable<CheckData> {
        let serviceUrl = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + '/v1/CheckRecurringAcknowledge';
        let requestBody: JsonApiWrap<CheckAcknowledgeRequest> = {
            data: {
                type: 'check-acknowledge-request',
                id: '',
                attributes: requestData
            }
        }
        let headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');
            headers["Acknowledgement-Consent"] = "true";

        return this.baseService.post<CheckAcknowledgeRequest, CheckData>(serviceUrl, headers, requestBody, true);
    };
}
